import { render, staticRenderFns } from "./TraceReportList.vue?vue&type=template&id=2f00bf90&scoped=true&"
import script from "./TraceReportList.vue?vue&type=script&lang=js&"
export * from "./TraceReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f00bf90",
  null
  
)

export default component.exports